import * as React from "react";
import { Grid } from "semantic-ui-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { login, logout } from "../store/modules/auth";

import configs from "../helpers/config";
import Loader from "./Loader";
import LoginMedico from "./LoginMedico";
import LoginPaciente from "./LoginPaciente";
import LoginTipo from "./LoginTipo";

import loginService from "../services/login.service";
import recuperacaoService from "../services/recuperacao.service";
import LoginColaborador from "./LoginColaborador";
import LoginDoisFatores from "./LoginDoisFatores";
import LoginConvenio from "./LoginConvenio";
import LoginEmpresa from "./LoginEmpresa";
import LoginTokenPaciente from "./LoginTokenPaciente";
import MedicosRegistro from "./MedicosRegistro";
import SolicitarSenha from "./SolicitarSenha";
import PacientesRegistro from "./PacientesRegistro";
import { showMessage } from '../helpers/helper';

export const application_agnostic_auth_token = "pajiP1745rR35btl5iM6hKHgpY5PnGe1TEFvQSR7Cw4=";

export const eTipo = Object.freeze({
    loginPaciente: 0,
    loginMedico: 1,
    loginConvenio: 2,
    loginEmpresa: 3,
    loginPacienteToken: 4,
    loginDoisFatores: 5,
    pacienteRegistro: 6,
    loginColaborador: 9,
})

class Login extends React.Component {
    constructor(props) {
        super(props);
        let _tipo = localStorage.getItem("tipo") || 0;

        this.state = {
            isLoading: false,
            tipo: parseInt(_tipo),
            token: "",
            recuperar: false,
        };
    }

    loginBase = async (request, credentials, page, onSuccess) => {
        try {
            this.setState({ ...this.state, isLoading: true });

            const {
                alterar_senha,
                duracao,
                success,
                user,
                message,
                portal,
                error,
                token,
                two_factor_prefix,
                two_factor_required,
                two_factor_size,
                two_factor_expiration,
                two_factor_device,
                two_factor_celular,
                two_factor_email,
                two_factor_tempo_espera_reenvio,
            } = await request(credentials);

            if (two_factor_required === true) {
                localStorage.setItem("tipo", this.state.tipo.toString());
                this.setState({
                    tipo: eTipo.loginDoisFatores,
                    two_factor: {
                        two_factor_prefix,
                        two_factor_required,
                        two_factor_size,
                        two_factor_expiration,
                        two_factor_device,
                        two_factor_celular,
                        two_factor_email,
                        two_factor_tempo_espera_reenvio,
                    }
                });
                return;
            }

            if (success) {
                localStorage.setItem("tipo", this.state.tipo.toString());
                this.props.login({ user, portal });
                if (onSuccess)
                    try {
                        onSuccess({ success, user, message, portal, error, token });
                    } catch { }

                if ((message && message === "ModificarSenha") || alterar_senha) {
                    showMessage("Favor informar nova senha de acesso.");
                    this.props.history.push(`/AlterarSenha`);
                } else {
                    if (this.state.tipo === eTipo.loginColaborador) {
                        this.efetuarLoginColaborador(user, token);
                    }
                    else {
                        this.props.history.push(`/${page}`);
                    }
                }
                return;
            }

            if (login.mensagem) {
                showMessage(login.mensagem);
            } else if (message) {
                showMessage(message);
            } else {
                showMessage("Dados de acesso inválidos!");
            }

            if (error & 2) {
                //paciente precisa passar por um novo processo de identificação
                if (credentials.chave.includes("@")) this.props.history.push(`/identificacaoPaciente?email=${credentials.chave}`);
                else
                    this.props.history.push(
                        `/identificacaoPaciente?chaveAcesso=${credentials.chave}&dataNascimento=${credentials.date}`
                    );
            }

        } catch (error) {
            console.log(error);
            showMessage("Serviço indisponível, tente novamente mais tarde.\r\n" + error);
        }
        finally {
            this.setState({ ...this.state, isLoading: false });
        }
    };

    loginPaciente = async (credentials) => {
        await this.loginBase(loginService.loginAsync, credentials, "Resultados");
    };

    loginPacienteToken = (credentials) => {
        this.loginBase(loginService.loginPacienteTokenAsync, credentials, "Resultados");
    };
    //Logins de médico também setam o token inter-aplicações para que o usuário não precise
    //relogar ao sair de um portal para o outro
    loginMedico = (credentials) => {
        this.loginBase(
            loginService.loginMedicoAsync,
            credentials,
            "ResultadosFiltro",
            ({ success, user, message, portal, error, token }) => {
                localStorage.setItem(
                    application_agnostic_auth_token,
                    JSON.stringify({
                        state: "loggedIn",
                        username: user,
                        token: token,
                        type: "medico",
                    })
                );
            }
        );
    };
    //Logins de médico também setam o token inter-aplicações para que o usuário não precise
    //relogar ao sair de um portal para o outro
    loginMedicoToken = (credentials) => {
        this.loginBase(
            loginService.loginMedicoTokenAsync,
            credentials,
            "ResultadosFiltro",
            ({ success, user, message, portal, error, token }) => {
                localStorage.setItem(
                    application_agnostic_auth_token,
                    JSON.stringify({
                        state: "loggedIn",
                        username: user,
                        token: token,
                        type: "medico",
                    })
                );
            }
        );
    };

    loginConvenio = (credentials) => {
        this.loginBase(loginService.loginConvenioAsync, credentials, "ResultadosFiltro");
    };

    loginEmpresa = (credentials) => {
        this.loginBase(loginService.loginProcedenciaAsync, credentials, "ResultadosFiltro");
    };

    loginColaborador = (credentials) => {
        this.loginBase(loginService.loginColaborador, credentials);
    }

    efetuarLoginColaborador = (user, token) => {
        const session = {
            state: "loggedIn",
            username: user,
            token: token,
            type: "colaborador",
        };
        localStorage.setItem(application_agnostic_auth_token, JSON.stringify(session));
        window.location.href = configs.CONSULTORIO_URL;
    }

    solicitarRecuperacao = async (credentials) => {
        let recuperar = true;

        try {
            this.setState({ isLoading: true });
            const { tipo } = this.state;
            const { success, mensagem } = await recuperacaoService.solicitarAsync({ tipo, ...credentials });

            if (success) {
                showMessage("Em instantes você receberá um email com instruções para troca de senha.");
                recuperar = false;
            } else {
                if (mensagem) {
                    showMessage(mensagem);
                } else {
                    showMessage("Não localizamos seu e-mail verifique o endereço informado e tente novamente.");
                }
            }
        } catch (error) {
            console.log(error);
            showMessage("Serviço indisponível, tente novamente mais tarde.");
        } finally {
            this.setState({ isLoading: false, recuperar });
        }
    };

    solicitarMedicosRegistro = async (credentials) => {
        let medicosregistro = true;

        try {
            this.setState({ isLoading: true });
            const { success, mensagem } = await recuperacaoService.medicoRegistroAsync({ ...credentials });

            if (success) {
                if (mensagem) {
                    showMessage(mensagem);
                } else {
                    showMessage(
                        "Cadastro realizado com sucesso. Por favor, aguarde que nossos colaboradores entrarão em contato o mais breve possível."
                    );
                }
                medicosregistro = false;
            } else {
                if (mensagem) {
                    showMessage(mensagem);
                } else {
                    showMessage("Não localizamos seu e-mail verifique o endereço informado e tente novamente.");
                }
            }
        } catch (error) {
            console.log(error);
            showMessage("Serviço indisponível, tente novamente mais tarde.");
        } finally {
            this.setState({ isLoading: false, medicosregistro });
        }
    };

    recuperar = () => {
        this.setState({ recuperar: true });
    };

    medicosregistro = () => {
        this.setState({ medicosregistro: true });
    };

    verificaravisoInicio = async () => {
        try {
            const response = await loginService.getResultadosAvisoInicio();
            const message = response?.data?.message?.trim() ?? null;
            if (message && typeof message === "string" && message !== "" && message !== "Desativado") {
                showMessage(message);
            }
        } catch (err) {
            console.error("Erro ao carregar aviso de início:", err);
        }
    };

    componentDidMount() {
        const search = new URLSearchParams(document.location.search);
        const token = search.get("token");

        if (token) {
            const medico = search.get("medico");
            if (medico === "true") {
                this.loginMedicoToken({ token: token });
            } else {
                const paciente = search.get("paciente");
                if (paciente === "true") {
                    localStorage.setItem("token", token);
                    this.props.history.push(`/resultados`);
                } else {
                    this.setState({ tipo: 4, token: token });
                }
            }
            console.log(token);
        } else {
            this.props.logout();
        }

        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        };

        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=` + configs.RECAPTCHA_SITE_KEY, function () {
            console.log("Script loaded!");
        });

        this.verificaravisoInicio();
    }

    getRecaptchaToken = (action) => {
        return new Promise((r, rj) => {
            //timeout
            window.setTimeout(rj, 5000);

            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: action }).then((token) => {
                    r(token);
                });
            })
        });
    }

    handleRegistroPaciente = async (registro) => {
        try {
            this.setState({ isLoading: true });
            const token = await this.getRecaptchaToken("registro_paciente");
            const { success, message } = await recuperacaoService.pacienteRegistroAsync({ ...registro, recaptcha_token: token });
            if (!success) {
                showMessage(message);
                return;
            }

            showMessage("Seu login foi criado com sucesso!");
            this.setState({
                tipo: eTipo.loginPaciente
            })
            return;
        } finally {
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { token, tipo, recuperar, isLoading, medicosregistro } = this.state;

        return (
            <Grid columns={2} stackable className="gridcolumnLogin">
                <Grid.Column>
                    <LoginTipo
                        tipoAtendimento={tipo}
                        onChange={(tipo) => this.setState({ tipo, recuperar: false, medicosregistro: false })}
                    />
                </Grid.Column>
                <Grid.Column className="gridcolumnLogin">
                    <LoginColaborador
                        className={tipo === eTipo.loginColaborador && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => { this.loginColaborador(credentials) }}
                        recuperar={this.recuperar}
                    />
                    <LoginPaciente
                        className={tipo === eTipo.loginPaciente && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.loginPaciente(credentials)}
                        registrarPaciente={() => this.setState({ tipo: eTipo.pacienteRegistro })}
                        recuperar={this.recuperar}
                    />
                    <LoginMedico
                        className={tipo === eTipo.loginMedico && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.loginMedico(credentials)}
                        recuperar={this.recuperar}
                        medicosregistro={this.medicosregistro}
                    />
                    <LoginEmpresa
                        className={tipo === eTipo.loginEmpresa && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.loginEmpresa(credentials)}
                        recuperar={this.recuperar}
                    />
                    <LoginConvenio
                        className={tipo === eTipo.loginConvenio && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.loginConvenio(credentials)}
                        recuperar={this.recuperar}
                    />
                    <LoginTokenPaciente
                        Token={token}
                        className={tipo === eTipo.loginPacienteToken && !recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.loginPacienteToken(credentials)}
                    />
                    {tipo === eTipo.loginDoisFatores && (
                        <LoginDoisFatores
                            onSucess={({ user, portal, alterar_senha, token }) => {
                                const tipoOriginal = Number(localStorage.getItem("tipo"));
                                this.props.login({ user, portal });

                                if (alterar_senha) {
                                    showMessage("Sua senha está expirada. Você será redirecionado para a alterção de senha.");
                                    this.props.history.push("/AlterarSenha");
                                    return;
                                }

                                if (tipoOriginal === eTipo.loginPaciente || tipoOriginal == eTipo.loginPacienteToken) {
                                    this.props.history.push("/Resultados");
                                    return;
                                }

                                if (tipoOriginal === eTipo.loginColaborador) {
                                    this.efetuarLoginColaborador(user, token);
                                    return;
                                }

                                this.props.history.push("/ResultadosFiltro");
                                return;
                            }}
                            {...this.state.two_factor}

                            onTokenUpdate={(token) => {
                                this.setState({
                                    two_factor: {
                                        ...this.state.two_factor,
                                        ...token
                                    }
                                })
                            }}

                            onExpired={() => this.setState({
                                tipo: Number(localStorage.getItem("tipo"))
                            })}
                        />
                    )}
                    {tipo === eTipo.pacienteRegistro && <PacientesRegistro onRegistro={this.handleRegistroPaciente}></PacientesRegistro>}
                    <SolicitarSenha
                        className={recuperar && !medicosregistro ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.solicitarRecuperacao(credentials)}
                        tipo={tipo}
                        onCancel={() => this.setState({ recuperar: false })}
                    />
                    <MedicosRegistro
                        className={medicosregistro && !recuperar ? "viewLogin" : "viewLoginToggle"}
                        onClick={(credentials) => this.solicitarMedicosRegistro(credentials)}
                    />
                </Grid.Column>
                <Loader isLoading={isLoading} />
            </Grid>
        );
    }
}

(function (w) {
    w.URLSearchParams =
        w.URLSearchParams ||
        function (searchString) {
            var self = this;
            self.searchString = searchString;
            self.get = function (name) {
                var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(self.searchString);
                if (results == null) {
                    return null;
                } else {
                    return decodeURI(results[1]) || 0;
                }
            };
        };
})(window);

const mapStateToProps = (state) => ({ auth: state.auth });
const mapDispatchToProps = (dispatch) => bindActionCreators({ login, logout }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Login);
